export function firstName(full: string | undefined): string {
  if (!full) return 'Гость';
  const first = full.trim().split(/\s+/)[0];
  return first || 'Гость';
}
